











































import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import Icon from '../Icon.vue';

@Component({
  components: { Icon },
})
export default class Modal extends Vue {
  @Prop({ default: 'title' })
  title: string;

  @Prop({ default: 'description' })
  description: string;

  @Inject('colorBrandDarkPrimary')
  colorBrandDarkPrimary!: string;

  @Inject('colorBlackPrimary')
  colorBlackPrimary!: string;

  @Prop({ default: false })
  isHalfFullModal: boolean;

  @Prop({ default: false })
  isNoPadding: boolean;

  @Prop({ default: false })
  isLargeWidth: boolean;

  get closeButtonColor() {
    return this.colorBlackPrimary;
  }

  get closeButtonHoverColor() {
    return this.colorBrandDarkPrimary;
  }

  isOpen = false;

  mounted() {
    this.$emit('openModalAdd', this.openModal);
    this.$emit('closeModalAdd', this.closeModal);
  }

  @Watch('isOpen')
  isOpenChange() {
    if (this.isOpen) {
      this.toggleBodyScrolling(false);
      this.addEscapeButtonListener();
    } else {
      this.toggleBodyScrolling(true);
      this.removeEscapeButtonListener();
    }
  }

  beforeDestroy() {
    this.toggleBodyScrolling(true);
  }

  onCloseClicked() {
    this.isOpen = false;
  }

  openModal() {
    this.isOpen = true;
  }

  closeModal() {
    this.isOpen = false;
  }

  toggleBodyScrolling(isScrolling: boolean) {
    const bodyElement = document.querySelector('body');

    if (bodyElement) {
      if (isScrolling) {
        bodyElement.style.overflow = 'auto';
      } else {
        bodyElement.style.overflow = 'hidden';
      }
    }
  }

  addEscapeButtonListener() {
    document.addEventListener('keydown', this.escapeButtonEvent);
  }

  removeEscapeButtonListener() {
    document.removeEventListener('keydown', this.escapeButtonEvent);
  }

  escapeButtonEvent = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      this.closeModal();
    }
  };
}
